import { defineMessages } from 'react-intl'

export default defineMessages({
  exportAllUsers: {
    id: 'OrganizationUsersPage.ExportAllUsers',
    defaultMessage: 'Export All Users'
  }
})
